import {TeachBlock, TeachBlockPage} from "./types";
const base = process.env.PUBLIC_URL || ``;

export const branch0Sergey = {
    start: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'SergeyAnalyzes',
        cardClick: 'patientSergeyCard',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'patientSergeyCardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    patientSergeyCardFirst: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "SergeyAnalyzes",
            closeClick: "tuktukSergey",
            pages: [`${base}/images/patient_sergey_enter_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    patientSergeyCard: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "SergeyAnalyzesAfter",
            closeClick: "sergeyFirstQuestion",
            pages: [`${base}/images/patient_sergey_enter_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    tuktukSergey: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'enterSergey', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    enterSergey: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Здравствуйте, доктор. Узнал, что Вы приехали к нам в город, решил сходить к Вам, узнать Ваше мнение! А то у меня случай особый!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyEnter.jpg`,
        buttons: [
            {text: "Здравствуйте, проходите.", type: "nextStep", gotoStep:'sergeyFirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyFirstQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Диагноз-то мне поставили - ПНГ. Я такого и не слышал, и не знал отродясь. Я подумал, что с таким диагнозом хорошо бы второе мнение узнать!<br><br>А то сейчас вот как лечиться надо - стал к себе прислушиваться. То сердце застучит как бешеное, то боли в животе странные непонятно где, потом само как-то проходит. Сил нет вообще. Во всех смыслах.<br><br>Я сделал проточную цитометрию. Мне сказали: вот по ней обычно все и понятно!',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '120px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'sergeyQuestions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Результаты проточной цитометрии", type: "nextStep", gotoStep:'SergeyAnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterAfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyQuestions: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Усталость при нагрузках", type: "nextStep", gotoStep:'sergeyQuestion1', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Трансфузии", type: "nextStep", gotoStep:'sergeyQuestion2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Одышка", type: "nextStep", gotoStep:'sergeyQuestion3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'sergeyQuestion4', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'sergeyQuestion5', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'sergeyQuestion6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'sergeyQuestion7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyFirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyQuestion1: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Да я иногда с кровати едва встать могу, не то что там спортом заниматься...',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyQuestion2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Да, было несколько трансфузий. Был такой низкий гемоглобин, что пришлось переливать кровь.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyQuestion3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'На второй этаж стоит подняться - и все. Воздуха не хватает и дышать тяжело.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyQuestion4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Да тут вроде бы нормально... ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyQuestion5: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Да тут вроде бы нормально...',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyQuestion6: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Да, были эпизоды темной мочи. Но я подумал, что такое бывает и у здорового человека. Мало ли, что-то не то съел.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyQuestion7: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Бывает периодически.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    SergeyAnalyzes: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "patientSergeyCardFirst",
            nextClick: "tuktukSergey",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_enter_1_table.jpg`],
                [`${base}/images/analiz_sergey_enter_2_table.jpg`],
                [`${base}/images/analiz_sergey_enter_3_table.jpg`],
                [`${base}/images/analiz_sergey_enter_4_table.jpg`],
                [`${base}/images/analiz_sergey_enter_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    SergeyAnalyzesAfter: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "patientSergeyCard",
            nextClick: "sergeyFirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_enter_1_table.jpg`],
                [`${base}/images/analiz_sergey_enter_2_table.jpg`],
                [`${base}/images/analiz_sergey_enter_3_table.jpg`],
                [`${base}/images/analiz_sergey_enter_4_table.jpg`],
                [`${base}/images/analiz_sergey_enter_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterAfterQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'sergeyEnterOsmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterAfterFisk', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterOsmotr: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'sergeyEnterOsmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'sergeyEnterOsmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'sergeyEnterOsmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterAfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterOsmotr1: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тахикардия. ЧСС - 94 уд/м',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterOsmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterOsmotr2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Наблюдается бледность кожных покровов и желтушность склер',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterOsmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterOsmotr3: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Все в норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterOsmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterAfterFisk: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Результаты проведенной проточной цитометрии выявили существенный размер ПНГ-клона в нескольких клеточных линиях. У Вас также наблюдаются характерные для ПНГ клинические и лабораторные признаки заболевания. Специалист корректно поставил Вам диагноз - пароксизмальная ночная гемоглобинурия.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterAfterFiskLink', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterAfterFisk2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterAfterFiskLink: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br> <a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br> (дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterAfterFisk', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterAfterFisk2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Ох... И что же с этим делать?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterMind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterMind: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>Любопытно. У пациента наблюдается активное течение заболевания, что обуславливает необходимость в патогенетической терапии. Какие опции терапии есть у пациента?</i>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterMindLink', value: false, redColor: false, answered: false},
            {text: "Почитать справочник", type: "nextStep", gotoStep:'sergeyEnterDocs', value: false, redColor: true, answered: false},
            {text: "Обдумать варианты", type: "nextStep", gotoStep:'sergeyEnterChoise', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterMindLink: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br> <a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br> (дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterMind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterDocs: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "sergeyGematogenEnter",
            pages: [
                {image: `${base}/images/sergey_teach_enter_1.png`, scroll: true},
                {image: `${base}/images/sergey_teach_enter_2.png`, scroll: true},
                {image: `${base}/images/sergey_teach_enter_3.png`, scroll: true},
                {image: `${base}/images/sergey_teach_enter_4.png`, scroll: true},
                {image: `${base}/images/sergey_teach_enter_5.png`, scroll: true},
                {image: `${base}/images/sergey_teach_enter_6.png`, scroll: true},
                {image: `${base}/images/sergey_teach_enter_7.png`, scroll: true},
                {image: `${base}/images/sergey_teach_enter_8.png`, scroll: true},
            ]
        }
    },
    sergeyGematogenEnter: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterMind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterChoise: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Экулизумаб", type: "nextStep", gotoStep:'sergeyEnterLine1Mind', value: false, redColor: false, answered: false},
            {text: "Равулизумаб", type: "nextStep", gotoStep:'sergeyEnterLine2Mind', value: false, redColor: false, answered: false},
            {text: "Иптакопан", type: "nextStep", gotoStep:'sergeyEnterLine3Mind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine1Mind: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>У пациента наблюдаются признаки активного внутрисосудистого гемолиза - лактатдегидрогеназа больше 1.5 верхней границы нормы, в жалобах пациента упоминались абдоминальные боли, эпизоды гемоглобинурии, желтушность кожи и склер, а также тахикардия.<br><br>Проточная цитометрия указывает на наличие клинически значимого размера ПНГ-клона, в результате чего могло произойти развитие комплемент-опосредованного внутрисосудистого гемолиза.<br><br>Таким образом, у пациента выявлены клинические и лабораторные признаки, которые могут свидетельствовать о высокой активности заболевания. На основании этого пациенту показано назначение патогенетической терапии.</i>',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '120px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine1MindLink', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine1Next', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine1MindLink: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br> <a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br> (дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine1Mind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine1Next: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Я назначаю Вам экулизумаб. Давайте я Вам расскажу, что Вам нужно будет сейчас сделать и как будет происходить терапия данным препаратом. <br><br><strong>Начальный цикл:</strong> 600мг препарата внутривенно капельно 1 раз в неделю в течение первых 4 недель.<br><strong>Поддерживающая терапия:</strong> 900 мг препарата, внутривенно капельно на 5-й неделе, с последующим введением 900 мг препарата каждые 14  дней.<br><br>После этого жду Вас на повторном приеме через 6 месяцев.',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '120px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine1NextLink', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine1Next2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine1NextLink: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Элизария® </strong><br>ЛП-№(000140)-(РГ-RU) от 18.02.2021',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine1Next', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine1Next2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Доктор! Спасибо большое!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine1Next3', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine1Next3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Надя (шепотом)',
        text: 'Доктор... Вакцинация!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine1Next4', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine1Next4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Прививка против менингококка имеется.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine1Next5', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine1Next5: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Хорошо. Тогда жду вас на повторный прием через 6 месяцев.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine1Next6', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine1Next6: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Обязательно буду!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'sergeyEnterLine1Finish', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine1Finish: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'sergeyE1Cabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine2Mind: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>У пациента наблюдаются признаки активного внутрисосудистого гемолиза - лактатдегидрогеназа больше 1.5 верхней границы нормы, в жалобах пациента упоминались абдоминальные боли, эпизоды гемоглобинурии, желтушность кожи и склер, а также тахикардия.<br><br>Проточная цитометрия указывает на наличие клинически значимого размера ПНГ-клона, в результате чего могло произойти развитие комплемент-опосредованного внутрисосудистого гемолиза.<br><br>Таким образом, у пациента выявлены клинические и лабораторные признаки, которые могут свидетельствовать о высокой активности заболевания. На основании этого пациенту показано назначение патогенетической терапии.</i>',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '120px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine2MindLink', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine2Next', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine2MindLink: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br> <a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br> (дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine2Mind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine2Next: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Я назначаю Вам терапию - равулизумаб. Давайте я Вам подробно расскажу, что Вам нужно сделать дальше и как будет происходить лечение.<br><br>Я рассчитаю дозу препарата на основе массы тела по таблице.<br>Первая доза называется <strong>нагрузочной дозой</strong>. Через 2 недели после получения нагрузочной дозы будет введена <strong>поддерживающая доза</strong> препарата. Затем поддерживающая доза будет вводиться каждые 8 недель.<br><br>После этого жду вас на повторном приеме через 6 месяцев.',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '120px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine2NextLink', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine2Next2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine2NextLink: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Ултомирис® </strong><br>ЛП-№(001862)-(РГ-RU) от 28.02.2023',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine2Next', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine2Next2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Доктор! Спасибо большое!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine2Next3', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine2Next3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'До свидания!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'sergeyEnterLine2Finish', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine2Finish: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'sergeyR1Cabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    sergeyEnterLine3Mind: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>У пациента наблюдаются признаки активного внутрисосудистого гемолиза - лактатдегидрогеназа больше 1.5 верхней границы нормы, низкий уровень гемоглобина, в жалобах пациента упоминались абдоминальные боли, эпизоды гемоглобинурии, желтушность кожи и склер, а также тахикардия.<br><br>Проточная цитометрия указывает на наличие клинически значимого размера ПНГ-клона, в результате чего могло произойти развитие комплемент-опосредованного внутрисосудистого гемолиза. Таким образом, у пациента выявлены клинические и лабораторные признаки, которые могут свидетельствовать о высокой активности заболевания.<br><br>Данному пациенту возможно назначение препарата из нового класса ингибиторов проксимального участка системы комплемента - иптакопан.<br><br><strong>Список источников</strong><br><ol><li>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024. Электронный ресурс. https://cr.minzdrav.gov.ru/preview-cr/695_2 (дата обращения: 08.07.2025)</li><li>ОХЛП: Общая характеристика лекарственного препарата Фабхальта® ЛП-№(006928)-(РГ-RU) от 19.09.2024</li></ol></i>',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Почитать справочник", type: "nextStep", gotoStep:'sergeyEnterLine3Docs', value: false, redColor: true, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Docs: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "sergeyGematogenEnter2",
            pages: [
                {image: `${base}/images/sergey_teach_enter_11.png`, scroll: true},
                {image: `${base}/images/sergey_teach_enter_12.png`, scroll: true},
            ]
        }
    },
    sergeyGematogenEnter2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3Next', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Next: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'У Вас наблюдается высокая активность заболевания, есть признаки гемолитической анемии. Я назначаю Вам иптакопан. Давайте я Вам расскажу подробно про прием этого препарата.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3NextLink', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3Next2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3NextLink: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine3Next', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Next2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Да, расскажите, пожалуйста, а то я никогда про такой препарат не слышал...',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3Next3', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Next3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Давайте расскажу более подробно. Иптакопан применяется в качестве монотерапии пароксизмальной ночной гемоглобинурии с гемолитической анемией. Данный препарат направленно воздействует на фактор B альтернативного пути системы комплемента, ключевого звена патогенеза заболевания. Такой механизм позволяет предотвратить разрушение эритроцитов иммунной системой.',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '120px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3Next3Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3Next4', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Next3Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine3Next3', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Next4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Это что-то новое?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3Next5', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Next5: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Да, этот препарат был зарегистрирован на территории РФ в 2024 году.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3Next5Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3Next6', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Next5Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Иптакопан. Государственный реестр лекарственных средств:</strong><br><a href="https://grls.rosminzdrav.ru/Grls_View_v2.aspx?routingGuid=2d2db46f-9cc9-4c0d-b04c-1e19748fc259">https://grls.rosminzdrav.ru/Grls_View_v2.aspx?routingGuid=2d2db46f-9cc9-4c0d-b04c-1e19748fc259</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine3Next5', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Next6: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'А мне надо будет ездить в больницу постоянно для введения препарата?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3Next7', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Next7: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Нет, это первая монотерапия в капсулах. Нужно принимать по 200 мг 2 раза в сутки. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3Next7Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3Next8', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Next7Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта® </strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine3Next8', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Next8: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'А мне надо будет переходить на какую-то специальную диету?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3Next9', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Next9: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Нет-нет, вы можете сохранить свой привычный рацион. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3Next9Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3Next10', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Next9Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта® </strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine3Next9', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Next10: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Перед началом приема иптакопана Вам необходимо пройти обязательную вакцинацию:<ol><li>Neisseria meningitidis</li><li>Streptococcus pneumoniae</li></ol>Также Вам рекомендована вакцинация против Haemophilus influenzae типа b.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3Next10Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3Next11', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Next10Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта® </strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine3Next10', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Next11: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Хорошо, надеюсь, лечение поможет!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3Next12', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Next12: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Будем наблюдать и делать все возможное.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3Next13', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Next13: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Всего доброго! До свидания, Надя.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'sergeyEnterLine3Finish', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3Finish: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'sergeyIPTA2Cabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuMind: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>У пациента наблюдаются признаки активного внутрисосудистого гемолиза - лактатдегидрогеназа больше 1.5 верхней границы нормы, низкий уровень гемоглобина, в жалобах пациента упоминались абдоминальные боли, эпизоды гемоглобинурии, желтушность кожи и склер, а также тахикардия.<br><br>Проточная цитометрия указывает на наличие клинически значимого размера ПНГ-клона, в результате чего могло произойти развитие комплемент-опосредованного внутрисосудистого гемолиза. Таким образом, у пациента выявлены клинические и лабораторные признаки, которые могут свидетельствовать о высокой активности заболевания.<br><br>Данному пациенту возможно назначение препарата из нового класса ингибиторов проксимального участка системы комплемента - иптакопан.<br><br><strong>Список источников</strong><br><ol><li>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024. Электронный ресурс. https://cr.minzdrav.gov.ru/preview-cr/695_2 (дата обращения: 08.07.2025)</li><li>ОХЛП: Общая характеристика лекарственного препарата Фабхальта® ЛП-№(006928)-(РГ-RU) от 19.09.2024</li></ol></i>',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Почитать справочник", type: "nextStep", gotoStep:'sergeyEnterLine3EcuDocs', value: false, redColor: true, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuDocs: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "sergeyGematogenEnter2Ecu",
            pages: [
                {image: `${base}/images/sergey_teach_enter_11.png`, scroll: true},
                {image: `${base}/images/sergey_teach_enter_12.png`, scroll: true},
            ]
        }
    },
    sergeyGematogenEnter2Ecu: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'У Вас наблюдается высокая активность заболевания, есть признаки гемолитической анемии. Я назначаю Вам иптакопан. Давайте я Вам расскажу подробно про прием этого препарата.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNextLink', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNextLink: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Да, расскажите, пожалуйста, а то я никогда про такой препарат не слышал...',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext3', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Давайте расскажу более подробно. Иптакопан применяется в качестве монотерапии пароксизмальной ночной гемоглобинурии с гемолитической анемией. Данный препарат направленно воздействует на фактор B альтернативного пути системы комплемента, ключевого звена патогенеза заболевания. Такой механизм позволяет предотвратить разрушение эритроцитов иммунной системой.',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '120px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext3Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext4', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext3Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext3', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Это что-то новое?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext5', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext5: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Да, этот препарат был зарегистрирован на территории РФ в 2024 году.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext5Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext6', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext5Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Иптакопан. Государственный реестр лекарственных средств:</strong><br><a href="https://grls.rosminzdrav.ru/Grls_View_v2.aspx?routingGuid=2d2db46f-9cc9-4c0d-b04c-1e19748fc259">https://grls.rosminzdrav.ru/Grls_View_v2.aspx?routingGuid=2d2db46f-9cc9-4c0d-b04c-1e19748fc259</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext5', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext6: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'А мне надо будет ездить в больницу постоянно для введения препарата?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext7', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext7: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Нет, это первая монотерапия в капсулах. Нужно принимать по 200 мг 2 раза в сутки. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext7Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext8', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext7Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта® </strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext8', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext8: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'А мне надо будет переходить на какую-то специальную диету?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext9', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext9: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Нет-нет, вы можете сохранить свой привычный рацион. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext9Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext10_0', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext9Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта® </strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext9', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext10_0: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Как будет происходить переход на новую терапию? Нужны ли вакцины?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext10', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext10: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Перед началом приема иптакопана Вам необходимо пройти обязательную вакцинацию:<ol><li>Neisseria meningitidis</li><li>Streptococcus pneumoniae</li></ol>Также Вам рекомендована вакцинация против Haemophilus influenzae типа b.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext10Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext11', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext10Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта® </strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext10', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext11: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Смотрите, для снижения потенциального риска гемолиза при резком прекращении лечения, при переходе с терапии экулизумабом лечение иптакопаном следует начинать не позднее чем через 1 неделю после введения последней дозы экулизумаба.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext11Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext12', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext11Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext11', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext12: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Будем наблюдать и делать все возможное.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuNext13', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuNext13: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Всего доброго! До свидания, Надя.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'sergeyEnterLine3EcuFinish', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3EcuFinish: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'sergeyIPTA2Cabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuMind: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>У пациента наблюдаются признаки активного внутрисосудистого гемолиза - лактатдегидрогеназа больше 1.5 верхней границы нормы, низкий уровень гемоглобина, в жалобах пациента упоминались абдоминальные боли, эпизоды гемоглобинурии, желтушность кожи и склер, а также тахикардия.<br><br>Проточная цитометрия указывает на наличие клинически значимого размера ПНГ-клона, в результате чего могло произойти развитие комплемент-опосредованного внутрисосудистого гемолиза. Таким образом, у пациента выявлены клинические и лабораторные признаки, которые могут свидетельствовать о высокой активности заболевания.<br><br>Данному пациенту возможно назначение препарата из нового класса ингибиторов проксимального участка системы комплемента - иптакопан.<br><br><strong>Список источников</strong><br><ol><li>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024. Электронный ресурс. https://cr.minzdrav.gov.ru/preview-cr/695_2 (дата обращения: 08.07.2025)</li><li>ОХЛП: Общая характеристика лекарственного препарата Фабхальта® ЛП-№(006928)-(РГ-RU) от 19.09.2024</li></ol></i>',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Почитать справочник", type: "nextStep", gotoStep:'sergeyEnterLine3RavuDocs', value: false, redColor: true, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuDocs: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "sergeyGematogenEnter2Ravu",
            pages: [
                {image: `${base}/images/sergey_teach_enter_11.png`, scroll: true},
                {image: `${base}/images/sergey_teach_enter_12.png`, scroll: true},
            ]
        }
    },
    sergeyGematogenEnter2Ravu: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'У Вас наблюдается высокая активность заболевания, есть признаки гемолитической анемии. Я назначаю Вам иптакопан. Давайте я Вам расскажу подробно про прием этого препарата.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNextLink', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNextLink: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Да, расскажите, пожалуйста, а то я никогда про такой препарат не слышал...',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext3', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Давайте расскажу более подробно. Иптакопан применяется в качестве монотерапии пароксизмальной ночной гемоглобинурии с гемолитической анемией. Данный препарат направленно воздействует на фактор B альтернативного пути системы комплемента, ключевого звена патогенеза заболевания. Такой механизм позволяет предотвратить разрушение эритроцитов иммунной системой.',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '120px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext3Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext4', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext3Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext3', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Это что-то новое?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext5', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext5: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Да, этот препарат был зарегистрирован на территории РФ в 2024 году.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext5Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext6', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext5Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Иптакопан. Государственный реестр лекарственных средств:</strong><br><a href="https://grls.rosminzdrav.ru/Grls_View_v2.aspx?routingGuid=2d2db46f-9cc9-4c0d-b04c-1e19748fc259">https://grls.rosminzdrav.ru/Grls_View_v2.aspx?routingGuid=2d2db46f-9cc9-4c0d-b04c-1e19748fc259</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext5', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext6: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'А мне надо будет ездить в больницу постоянно для введения препарата?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext7', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext7: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Нет, это первая монотерапия в капсулах. Нужно принимать по 200 мг 2 раза в сутки. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext7Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext8', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext7Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта® </strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext8', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext8: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'А мне надо будет переходить на какую-то специальную диету?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext9', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext9: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Нет-нет, вы можете сохранить свой привычный рацион. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext9Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext10_0', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext9Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта® </strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext9', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext10_0: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Как будет происходить переход на новую терапию? Нужны ли вакцины?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext10', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext10: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Перед началом приема иптакопана Вам необходимо пройти обязательную вакцинацию:<ol><li>Neisseria meningitidis</li><li>Streptococcus pneumoniae</li></ol>Также Вам рекомендована вакцинация против Haemophilus influenzae типа b.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext10Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext11', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext10Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта® </strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext10', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext11: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Смотрите, для снижения потенциального риска гемолиза при резком прекращении лечения, при переходе с терапии равулизумабом лечение иптакопаном следует начинать не позднее чем через 6 недель после введения последней дозы равулизумаба.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext11Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext12', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext11Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext11', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext12: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Будем наблюдать и делать все возможное.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3RavuNext13', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuNext13: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Всего доброго! До свидания, Надя.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'sergeyEnterLine3RavuFinish', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEnterLine3RavuFinish: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'sergeyIPTA2Cabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    sergeyE1Cabinet: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'sergeyE1Analyzes',
        cardClick: 'sergeyE1CardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'sergeyE1CardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1CardFirst: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyE1Analyzes",
            closeClick: "sergeyE1tuktuk",
            pages: [`${base}/images/patient_sergey_e1_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1Card: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyE1AnalyzesAfter",
            closeClick: "sergeyE1FirstQuestion",
            pages: [`${base}/images/patient_sergey_e1_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1tuktuk: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тихий стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'sergeyE1enter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1enter: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Здравствуйте, доктор. А я опять к Вам!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyEnter.jpg`,
        buttons: [
            {text: "Здравствуйте,  как вы?", type: "nextStep", gotoStep:'sergeyE1FirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1FirstQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Лечусь. Все делаю по вашим рекомендациям. Стало немного лучше, но нет привычной бодрости, силы. Это теперь всегда вот так будет? А то я в отпуск с дочкой хотел поехать в горы.. Но это мне пока, чувствую, рановато... ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'sergeyE1Questions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'sergeyE1AnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE1AfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1Questions: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Усталость", type: "nextStep", gotoStep:'sergeyE1Question1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в животе", type: "nextStep", gotoStep:'sergeyE1Question2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Трансфузии", type: "nextStep", gotoStep:'sergeyE1Question3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'sergeyE1Question4', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'sergeyE1Question5', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'sergeyE1Question6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'sergeyE1Question7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'sergeyE1Question8', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE1FirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1Question1: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Стало немного лучше. Но на работе частенько приходится делать перерывы. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1Question2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1Question3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Была одна... Я тогда еще заболел - пневмония была. И гемоглобин меньше 70 г/л падал!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1Question4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1Question5: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Это я даже не пытаюсь. С такой усталостью вечной не до зарядки, про более существенные нагрузки я вообще молчу.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1Question6: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Все нормально.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1Question7: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Не было.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1Question8: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1Analyzes: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyE1CardFirst",
            nextClick: "sergeyE1tuktuk",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_e1_1_table.jpg`],
                [`${base}/images/analiz_sergey_e1_2_table.jpg`],
                [`${base}/images/analiz_sergey_e1_3_table.jpg`],
                [`${base}/images/analiz_sergey_e1_4_table.jpg`],
                [`${base}/images/analiz_sergey_e1_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1AnalyzesAfter: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyE1Card",
            nextClick: "sergeyE1FirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_e1_1_table.jpg`],
                [`${base}/images/analiz_sergey_e1_2_table.jpg`],
                [`${base}/images/analiz_sergey_e1_3_table.jpg`],
                [`${base}/images/analiz_sergey_e1_4_table.jpg`],
                [`${base}/images/analiz_sergey_e1_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1AfterQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'sergeyE1Osmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE1AfterFisk', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1Osmotr: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'sergeyE1Osmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'sergeyE1Osmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'sergeyE1Osmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE1AfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1Osmotr1: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тахикардия. ЧСС - 102 уд/м',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE1Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1Osmotr2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Кожные покровы менее бледные, но желтушность сохраняется',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE1Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1Osmotr3: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Все в норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE1Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1Mind: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>Пациент уже 6 месяцев получает терапию ингибитором С5. Результаты лабораторных исследований указывают на субоптимальный ответ на патогенетическую терапию. Уровень гемоглобина в промежутке от 80 до 100 г/л.<br><br>За последние 6 месяцев также была проведена одна гемотрансфузия. Общий билирубин и уровень ЛДГ выше нормы, что в совокупности может указывать на наличие активного гемолиза.</i>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyE1MindLink', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE1AfterFisk', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1MindLink: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE1Mind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1AfterFisk: {
        patient: 'Sergey',
        branch: 0,
        name: '❗ ВНИМАНИЕ',
        text: '📘 Доступен новый материал! Изучите его как можно скорее, чтобы получить награду и увеличить шанс на верный ответ! 🏅🎉<br>👀 Нажмите <strong>"Читать справочник"</strong> – там свежий материал!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Читать справочник", type: "nextStep", gotoStep:'sergeyE1Docs', value: false, redColor: true, answered: false},
            {text: "Обдумать варианты", type: "nextStep", gotoStep:'sergeyE1Choise', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1Docs: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "sergeyGematogenE1",
            pages: [
                {image: `${base}/images/sergey_teach_e1_1.png`, scroll: true},
            ]
        }
    },
    sergeyGematogenE1: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE1AfterFisk', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1Choise: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Продолжить терапию экулизумабом", type: "nextStep", gotoStep:'sergeyE1ChoiseLine1', value: false, redColor: false, answered: false},
            {text: "Экулизумаб\n(сокращение интервала введения)", type: "nextStep", gotoStep:'sergeyE1ChoiseLine2', value: false, redColor: false, answered: false},
            {text: "Равулизумаб", type: "nextStep", gotoStep:'sergeyE1ChoiseLine3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)'},
            {text: "Иптакопан", type: "nextStep", gotoStep:'sergeyE1ChoiseLine4', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)'}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine1: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Давайте продолжим введение экулизумаба и посмотрим на динамику.<br><br>900 мг препарата внутривенно капельно каждые 14 дней.<br><br>Жду Вас на повторный прием через 6 месяцев. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyE1ChoiseLine1Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE1ChoiseLine1_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine1Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Элизария®</strong><br>ЛП-№(000140)-(РГ-RU) от 18.02.2021',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE1ChoiseLine1', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine1_2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Как скажете, доктор! Я Вам доверяю.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE1ChoiseLine1_3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine1_3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Всего доброго! Надя, доктор, спасибо Вам большое!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet2.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'sergeyE1ChoiseLine1Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine1Finish: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'sergeyE2Cabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Давайте попробуем сократить интервал между введением препаратов.<br><br>900 мг препарата внутривенно капельно каждые 12 дней.<br><br>Жду Вас с результатами исследований через 6 месяцев.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyE1ChoiseLine2Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE1ChoiseLine2_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine2Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Элизария®</strong><br>ЛП-№(000140)-(РГ-RU) от 18.02.2021',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE1ChoiseLine2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine2_2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Отлично! Спасибо, доктор.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE1ChoiseLine2_3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine2_3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Хорошего Вам дня! До встречи! ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet2.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'sergeyE1ChoiseLine2Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine2Finish: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'sergeyEP1Cabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Давайте сменим терапию. Я Вам подробно распишу схему перехода.<br><br>Через 2 недели после последней инфузии экулизумаба мы введем <strong>первую нагрузочную дозу</strong>. Затем <strong>поддерживающая доза</strong> будет вводиться каждые 8 недель.<br><br>И жду вас через 6 месяцев по результатам анализов на прием!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyE1ChoiseLine3Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE1ChoiseLine3_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine3Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Ултомирис® </strong><br>ЛП-№(001862)-(РГ-RU) от 28.02.2023',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE1ChoiseLine3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine3_2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Спасибо, доктор! Надеюсь, это поможет...',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE1ChoiseLine3_3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine3_3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Отличного вечера Вам, Надя и доктор!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet2.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'sergeyE1ChoiseLine3Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine3Finish: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'sergeyR1EcuCabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine4: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления ',
        text: '<i>Пациент в настоящее время имеет субоптимальный ответ на патогенетическую терапию - низкий уровень гемоглобина, среднее значение которого составило 95 г/л за последние 6 месяцев. У пациента также была трансфузия за данный период. <br>У пациента отмечаются признаки внутрисосудистого и внесосудистого гемолиза, выражающегося в таких показателях, как:<ul><li>Снижение уровня гемоглобина</li><li>Повышенная активность ЛДГ >1.5хВГН</li><li>Гипербилирубинемия за счёт непрямой фракции >1.5хВГН</li><li>Ретикулоцитоз >120 тыс/мкл</li><li>Положительная прямая проба Кумбса</li></ul>Активный гемолиз может быть причиной субоптимального ответа на патогенетическую терапию.</i>',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyE1ChoiseLine4Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE1ChoiseLine4_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine4Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br> (дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE1ChoiseLine4', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine4_2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'У Вас наблюдается высокая активность заболевания, есть признаки и внесосудистого, и внутрисосудистого гемолиза. Я назначаю Вам терапию иптакопаном. Давайте я Вам расскажу подробно про прием этого препарата.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyE1ChoiseLine4_2Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuMind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE1ChoiseLine4_2Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)<br><br><strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE1ChoiseLine4_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    sergeyE2Cabinet: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'sergeyE2Analyzes',
        cardClick: 'sergeyE2CardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'sergeyE2CardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2CardFirst: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyE2Analyzes",
            closeClick: "sergeyE2tuktuk",
            pages: [`${base}/images/patient_sergey_e2_e3_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2Card: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyE2AnalyzesAfter",
            closeClick: "sergeyE2FirstQuestion",
            pages: [`${base}/images/patient_sergey_e2_e3_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2tuktuk: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тихий стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'sergeyE2enter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2enter: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Здравствуйте, опять я к вам.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyEnter.jpg`,
        buttons: [
            {text: "Здравствуйте, проходите, как вы?", type: "nextStep", gotoStep:'sergeyE2enter2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2enter2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Чувствую себя не очень хорошо. Если честно, мне стало немного хуже, чем было на прошлом визите. А еще... Доктор. Я не знаю, связано ли это. Но у меня еще добавились проблемы с потенцией, а ведь мне 35 лет всего! Как-то все это грустно.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyEnter.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE2FirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2FirstQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Не переживайте, сейчас мы Вас осмотрим, все проанализируем и решим, что делать дальше.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'sergeyE2Questions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'sergeyE2AnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE2AfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2Questions: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Усталость", type: "nextStep", gotoStep:'sergeyE2Question1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в животе", type: "nextStep", gotoStep:'sergeyE2Question2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Трансфузии", type: "nextStep", gotoStep:'sergeyE2Question3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'sergeyE2Question4', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'sergeyE2Question5', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'sergeyE2Question6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'sergeyE2Question7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'sergeyE2Question8', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE2FirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2Question1: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Последние часы на работе стали совсем невыносимы. Раньше так не было.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2Question2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2Question3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Было еще две. Мне прям в этот период очень плохо было: операцию перенес - холецистэктомию. И ОРВИ еще.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2Question4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2Question5: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Одышка как с кровати встаю. И так весь день. Какие мне нагрузки.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2Question6: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2Question7: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Периодически снова стало происходить такое.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2Question8: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2Analyzes: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyE2CardFirst",
            nextClick: "sergeyE2tuktuk",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_e2_1_table.jpg`],
                [`${base}/images/analiz_sergey_e2_2_table.jpg`],
                [`${base}/images/analiz_sergey_e2_3_table.jpg`],
                [`${base}/images/analiz_sergey_e2_4_table.jpg`],
                [`${base}/images/analiz_sergey_e2_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [433],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2AnalyzesAfter: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyE2Card",
            nextClick: "sergeyE2FirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_e2_1_table.jpg`],
                [`${base}/images/analiz_sergey_e2_2_table.jpg`],
                [`${base}/images/analiz_sergey_e2_3_table.jpg`],
                [`${base}/images/analiz_sergey_e2_4_table.jpg`],
                [`${base}/images/analiz_sergey_e2_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [433],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2AfterQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'sergeyE2Osmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE2Mind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2Osmotr: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'sergeyE2Osmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'sergeyE2Osmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'sergeyE2Osmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE2AfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2Osmotr1: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тахикардия. ЧСС - 107 уд/м',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2Osmotr2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Кожные покровы менее бледные, но желтушность сохраняется',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2Osmotr3: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Все в норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2Mind: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>Текущий курс терапии не позволил достичь ожидаемых результатов. За последние 6 месяцев уровень гемоглобина упал ниже 90 г/л, общий уровень билирубина также превысил 1.5хВГН. Помимо этого у пациента наблюдается ретикулоцитоз, а также прямая проба Кумбса стала положительной! Все это может указывать на возникший на фоне терапии C5 внесосудистый гемолиз, а также сохраняющийся внутрисосудистый гемолиз. У пациента все еще субоптимальный ответ на текущую патогенетическую терапию.<br><br>Стоит ли рассмотреть новые опции терапии?</i>',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyE2MindLink', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE2AfterFisk', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2MindLink: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024. </strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE2Mind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2AfterFisk: {
        patient: 'Sergey',
        branch: 0,
        name: '❗ ВНИМАНИЕ',
        text: '📘 Доступны новые материалы! Изучите их как можно скорее, чтобы получить награду и увеличить шанс на верный ответ! 🏅🎉<br>👀 Нажмите <strong>"Читать справочник"</strong>.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Читать справочник", type: "nextStep", gotoStep:'sergeyE2Docs', value: false, redColor: true, answered: false},
            {text: "Обдумать варианты", type: "nextStep", gotoStep:'sergeyE2Choise', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2Docs: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "sergeyGematogenE2",
            pages: [
                {image: `${base}/images/sergey_teach_e2_1.png`, scroll: true},
                {image: `${base}/images/sergey_teach_e2_2.png`, scroll: true},
                {image: `${base}/images/sergey_teach_e2_3.png`, scroll: true},
            ]
        }
    },
    sergeyGematogenE2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE2AfterFisk', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2Choise: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Экулизумаб\n(сокращение интервала введения)", type: "closeTelegramBot", gotoStep:'sergeyEP1Cabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
            {text: "Равулизумаб", type: "nextStep", gotoStep:'sergeyE2ChoiseLine2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)'},
            {text: "Иптакопан", type: "nextStep", gotoStep:'sergeyE2ChoiseLine3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)'},
            {text: "Продолжить терапию экулизумабом", type: "nextStep", gotoStep:'sergeyE2ChoiseLine4', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2ChoiseLine2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Давайте сменим терапию. Я Вам подробно распишу схему перехода.<br><br>Через 2 недели после последней инфузии экулизумаба мы введем первую, <strong>нагрузочную дозу</strong> равулизумаба. Через 2 недели после получения нагрузочной дозы будет введена <strong>поддерживающая доза</strong> препарата. Затем поддерживающая доза будет вводиться каждые 8 недель.<br><br>И жду вас через 6 месяцев по результатам анализов на прием!',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyE2ChoiseLine2Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE2ChoiseLine2_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2ChoiseLine2Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Ултомирис®</strong><br>ЛП-№(001862)-(РГ-RU) от 28.02.2023',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE2ChoiseLine2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2ChoiseLine2_2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Спасибо, доктор! Надеюсь, это поможет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE2ChoiseLine2Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2ChoiseLine2Finish: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'sergeyR3Cabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2ChoiseLine3: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: 'В связи с возникшим внесосудистым гемолизом есть основания рассмотреть другие опции патогенетической терапии ПНГ, действие которых направлено на проксимальный участок системы комплемента. Что можно назначить данному пациенту?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyE2ChoiseLine3Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE2ChoiseLine3_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2ChoiseLine3Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)<br><br><strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE2ChoiseLine3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2ChoiseLine3_2: {
        patient: 'Sergey',
        branch: 0,
        name: '❗ ВНИМАНИЕ',
        text: '📘 Доступны новые материалы! Изучите их как можно скорее, чтобы получить награду и увеличить шанс на верный ответ! 🏅🎉<br>👀 Нажмите <strong>"Читать справочник"</strong>.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Читать справочник", type: "nextStep", gotoStep:'sergeyE2ChoiseLine3Docs', value: false, redColor: true, answered: false},
            {text: "Сделать назначение", type: "nextStep", gotoStep:'sergeyE2ChoiseLine3_3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2ChoiseLine3Docs: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "sergeyGematogenLine3E2",
            pages: [
                {image: `${base}/images/sergey_teach_e2_11.png`, scroll: true},
                {image: `${base}/images/sergey_teach_e2_12.png`, scroll: true},
            ]
        }
    },
    sergeyGematogenLine3E2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE2ChoiseLine3_2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2ChoiseLine3_3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'У вас наблюдаются признаки внутри- и внесосудистого гемолиза, поэтому необходимо сменить терапию с терминального ингибитора системы комплемента на проксимальный ингибитор - иптакопан. Давайте я Вам расскажу подробно про прием этого препарата.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet2.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyE2ChoiseLine3_3Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuMind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2ChoiseLine3_3Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)<br><br><strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE2ChoiseLine3_3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2ChoiseLine4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Давайте все-таки продолжим принимать экулизумаб и посмотрим на динамику.<br><br><strong>Поддерживающая терапия:</strong> 900 мг препарата, внутривенно капельно каждые 14 дней.<br><br>Жду Вас на повторный прием через 6 месяцев.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyE2ChoiseLine4Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE2ChoiseLine4_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2ChoiseLine4Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Элизария®</strong><br>ЛП-№(000140)-(РГ-RU) от 18.02.2021',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE2ChoiseLine4', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2ChoiseLine4_2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Да? Ладно, продолжу лечиться.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE2ChoiseLine4_3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2ChoiseLine4_3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Надя',
        text: 'Сергей, не сдаемся! Вам еще покорять Гималаи.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE2ChoiseLine4_4', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2ChoiseLine4_4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей (смеется)',
        text: 'Спасибо, что верите в меня! До свидания! ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet2.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE2ChoiseLine4Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE2ChoiseLine4Finish: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'sergeyE3Cabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    sergeyE3Cabinet: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'sergeyE3Analyzes',
        cardClick: 'sergeyE3CardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'sergeyE3CardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3CardFirst: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyE3Analyzes",
            closeClick: "sergeyE3tuktuk",
            pages: [`${base}/images/patient_sergey_e2_e3_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3Card: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyE3AnalyzesAfter",
            closeClick: "sergeyE3FirstQuestion",
            pages: [`${base}/images/patient_sergey_e2_e3_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3tuktuk: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тихий стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'sergeyE3enter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3enter: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Доктор. Я не знаю, на что мне надеяться. Мне кажется, я больше не могу. Извините, что без преамбул. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyEnter.jpg`,
        buttons: [
            {text: "Здравствуйте, проходите.", type: "nextStep", gotoStep:'sergeyE3FirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3FirstQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Сейчас со всем разберемся, без паники.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'sergeyE3Questions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'sergeyE3AnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE3AfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3Questions: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Усталость", type: "nextStep", gotoStep:'sergeyE3Question1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в животе", type: "nextStep", gotoStep:'sergeyE3Question2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Трансфузии", type: "nextStep", gotoStep:'sergeyE3Question3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'sergeyE3Question4', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'sergeyE3Question5', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'sergeyE3Question6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'sergeyE3Question7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'sergeyE3Question8', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE3FirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3Question1: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Усталость жуткая все время. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3Question2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3Question3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Три раза пришлось делать трансфузии за последние полгода',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3Question4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3Question5: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Не спрашивайте... Пока улучшений не было... Но я не сдаюсь. Хотя бы разминку делаю. Стараюсь. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3Question6: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3Question7: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Да, обратил внимание, было пару раз.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3Question8: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyE3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3Analyzes: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyE3CardFirst",
            nextClick: "sergeyE3tuktuk",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_e3_1_table.jpg`],
                [`${base}/images/analiz_sergey_e3_2_table.jpg`],
                [`${base}/images/analiz_sergey_e3_3_table.jpg`],
                [`${base}/images/analiz_sergey_e3_4_table.jpg`],
                [`${base}/images/analiz_sergey_e3_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3AnalyzesAfter: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyE3Card",
            nextClick: "sergeyE3FirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_e3_1_table.jpg`],
                [`${base}/images/analiz_sergey_e3_2_table.jpg`],
                [`${base}/images/analiz_sergey_e3_3_table.jpg`],
                [`${base}/images/analiz_sergey_e3_4_table.jpg`],
                [`${base}/images/analiz_sergey_e3_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3AfterQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'sergeyE3Osmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE3Mind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3Osmotr: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'sergeyE3Osmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'sergeyE3Osmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'sergeyE3Osmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE3AfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3Osmotr1: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тахикардия. ЧСС - 107 уд/м',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE3Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3Osmotr2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Кожные покровы менее бледные, но желтушность сохраняется',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE3Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3Osmotr3: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Все в норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE3Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3Mind: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>Пациент получает терапию экулизумабом уже 1.5 года, но сохраняются признаки внутрисосудистого гемолиза, выражающегося в повышенной активности ЛДГ. Ретикулоцитоз и гипербилирубинемия за счет непрямой фракии являются признаками внесосудистого гемолиза<br><br>Субоптимальный ответ на терапию наблюдается уже длительное время - уровень гемоглобина ниже 100 г/л, присутствует трансфузионная зависимость. Учитывая данные факторы, необходимо ли скорректировать текущий курс терапии?</i>',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyE3MindLink', value: false, redColor: false, answered: false},
            {text: "Иптакопан", type: "nextStep", gotoStep:'sergeyE3ChoiseLine1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)'},
            {text: "Равулизумаб", type: "nextStep", gotoStep:'sergeyE3ChoiseLine2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)'},
            {text: "Экулизумаб\n(сокращение интервала введения)", type: "closeTelegramBot", gotoStep:'sergeyEP1Cabinet', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3MindLink: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024. </strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE3Mind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3ChoiseLine1: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>Пациент в настоящее время имеет субоптимальный ответ на патогенетическую терапию - низкий уровень гемоглобина. Недостаточный ответ на терапию может быть связан с активным гемолизом, на которые указывают показатели гемоглобина, ЛДГ, билирубина, абсолютное число ретикулоцитов, а также положительная прямая проба Кумбса. У данного пациента есть показания для назначения иптакопана.</i>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyE3ChoiseLine1Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuMind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3ChoiseLine1Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024. </strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)<br><br><strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE3ChoiseLine1', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3ChoiseLine2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Давайте сменим терапию. Я Вам подробно распишу схему перехода.<br><br>Через 2 недели после последней инфузии экулизумаба мы введем первую, <strong>нагрузочную дозу</strong> равулизумаба. Затем <strong>поддерживающая доза</strong> будет вводиться каждые 8 недель <br><br>И жду вас через 6 месяцев по результатам анализов на прием!',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyE3ChoiseLine2Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyE3ChoiseLine2_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3ChoiseLine2Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Ултомирис®</strong><br>ЛП-№(001862)-(РГ-RU) от 28.02.2023',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyE3ChoiseLine2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3ChoiseLine2_2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Спасибо, доктор! Надеюсь, это поможет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'sergeyE3ChoiseLine2Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyE3ChoiseLine2Finish: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'sergeyR1EcuCabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    sergeyEP1Cabinet: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'sergeyEP1Analyzes',
        cardClick: 'sergeyEP1CardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'sergeyEP1CardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1CardFirst: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyEP1Analyzes",
            closeClick: "sergeyEP1tuktuk",
            pages: [`${base}/images/patient_sergey_ep1_ep2_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1Card: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyEP1AnalyzesAfter",
            closeClick: "sergeyEP1FirstQuestion",
            pages: [`${base}/images/patient_sergey_ep1_ep2_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1tuktuk: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тихий стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'sergeyEP1enter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1enter: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Здравствуйте, доктор. Привет, Надя. Это снова я. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyEnter.jpg`,
        buttons: [
            {text: "Здравствуйте, как самочувствие?", type: "nextStep", gotoStep:'sergeyEP1FirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1FirstQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Лечусь! Лечусь.. Сил не было - и нет. Я, кажется, устаю уже от того только, что утром глаза открываю. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'sergeyEP1Questions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'sergeyEP1AnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEP1AfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1Questions: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Усталость", type: "nextStep", gotoStep:'sergeyEP1Question1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в животе", type: "nextStep", gotoStep:'sergeyEP1Question2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Трансфузии", type: "nextStep", gotoStep:'sergeyEP1Question3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'sergeyEP1Question4', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'sergeyEP1Question5', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'sergeyEP1Question6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'sergeyEP1Question7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'sergeyEP1Question8', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEP1FirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1Question1: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Усталость никуда не ушла. К ней еще добавилась усталость от сочувственных взглядов коллег.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyEP1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1Question2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyEP1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1Question3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Не было.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyEP1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1Question4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyEP1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1Question5: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'По-прежнему, физкультуры  в моей жизни - ноль. Не получается. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyEP1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1Question6: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyEP1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1Question7: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Периодически бывает.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyEP1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1Question8: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyEP1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1Analyzes: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyEP1CardFirst",
            nextClick: "sergeyEP1tuktuk",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_ep1_1_table.jpg`],
                [`${base}/images/analiz_sergey_ep1_2_table.jpg`],
                [`${base}/images/analiz_sergey_ep1_3_table.jpg`],
                [`${base}/images/analiz_sergey_ep1_4_table.jpg`],
                [`${base}/images/analiz_sergey_ep1_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [361],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1AnalyzesAfter: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyEP1Card",
            nextClick: "sergeyEP1FirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_ep1_1_table.jpg`],
                [`${base}/images/analiz_sergey_ep1_2_table.jpg`],
                [`${base}/images/analiz_sergey_ep1_3_table.jpg`],
                [`${base}/images/analiz_sergey_ep1_4_table.jpg`],
                [`${base}/images/analiz_sergey_ep1_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [361],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1AfterQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'sergeyEP1Osmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEP1Mind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1Osmotr: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'sergeyEP1Osmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'sergeyEP1Osmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'sergeyEP1Osmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEP1AfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1Osmotr1: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тахикардия. ЧСС - 102 уд/м',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEP1Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1Osmotr2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Кожные покровы менее бледные, но желтушность сохраняется',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEP1Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1Osmotr3: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Все в норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEP1Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1Mind: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>Текущий курс терапии не позволил достичь ожидаемых результатов. За последние 6 месяцев уровень гемоглобина упал ниже 90 г/л, общий уровень билирубина также превысил 1.5хВГН. Помимо этого у пациента наблюдается ретикулоцитоз, а также прямая проба Кумбса стала положительной! Все это может указывать на возникший на фоне терапии C5 внесосудистый гемолиз, а также сохраняющийся внутрисосудистый гемолиз. У пациента все еще субоптимальный ответ на текущую патогенетическую терапию.<br><br>Стоит ли рассмотреть новые опции терапии?</i>',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEP1MindLink', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEP1AfterFisk', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1MindLink: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEP1Mind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1AfterFisk: {
        patient: 'Sergey',
        branch: 0,
        name: '⚠️ ВНИМАНИЕ!',
        text: '📘 Доступны новые материалы! Изучите их как можно скорее, чтобы получить награду и увеличить шанс на верный ответ! 🏅🎉<br>👀 Нажмите <strong>"Читать справочник"</strong>.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Читать справочник", type: "nextStep", gotoStep:'sergeyEP1Docs', value: false, redColor: true, answered: false},
            {text: "Обдумать варианты", type: "nextStep", gotoStep:'sergeyEP1Choise', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1Docs: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "sergeyGematogenEP1",
            pages: [
                {image: `${base}/images/sergey_teach_ep1_1.png`, scroll: true},
                {image: `${base}/images/sergey_teach_ep1_2.png`, scroll: true},
                {image: `${base}/images/sergey_teach_ep1_3.png`, scroll: true},
            ]
        }
    },
    sergeyGematogenEP1: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEP1AfterFisk', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1Choise: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Равулизумаб", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)'},
            {text: "Иптакопан", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)'},
            {text: "Продолжить терапию экулизумабом", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine3', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1ChoiseLine1: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Давайте сменим терапию. Я Вам подробно распишу схему перехода.<br><br>Через 2 недели после последней инфузии экулизумаба мы введем первую нагрузочную дозу равулизумаба. Через 2 недели после получения нагрузочной дозы будет введена поддерживающая доза препарата. Затем поддерживающая доза будет вводиться каждые 8 недель.<br><br>И жду вас через 6 месяцев по результатам анализов на прием!',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine1Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine1_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1ChoiseLine1Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Ултомирис®</strong><br>ЛП-№(001862)-(РГ-RU) от 28.02.2023',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine1', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1ChoiseLine1_2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Спасибо, доктор! Надеюсь, это поможет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine1Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1ChoiseLine1Finish: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'sergeyR1EcuCabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1ChoiseLine2: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>В связи с возникшим внесосудистым гемолизом есть основания рассмотреть другие опции патогенетической терапии ПНГ, действие которых направлено на проксимальный участок системы комплемента. Что можно назначить данному пациенту?</i>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine2Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine2_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1ChoiseLine2Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)<br><br><strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1ChoiseLine2_2: {
        patient: 'Sergey',
        branch: 0,
        name: '⚠️ ВНИМАНИЕ!',
        text: '📘 Доступны новые материалы! Изучите их как можно скорее, чтобы получить награду и увеличить шанс на верный ответ! 🏅🎉<br>👀 Нажмите <strong>"Читать справочник"</strong>.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Читать справочник", type: "nextStep", gotoStep:'sergeyEP1DocsLine2', value: false, redColor: true, answered: false},
            {text: "Сделать назначение", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine2_4', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1DocsLine2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "sergeyGematogenEP1Line2",
            pages: [
                {image: `${base}/images/sergey_teach_ep1_11.png`, scroll: true},
                {image: `${base}/images/sergey_teach_ep1_12.png`, scroll: true},
                {image: `${base}/images/sergey_teach_ep1_13.png`, scroll: true},
            ]
        }
    },
    sergeyGematogenEP1Line2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine2_2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1ChoiseLine2_3: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Сделать назначение", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine2_4', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1ChoiseLine2_4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'У вас наблюдаются признаки внутри- и внесосудистого гемолиза, поэтому необходимо сменить терапию с терминального ингибитора системы комплемента на проксимальный ингибитор - иптакопан. Давайте я Вам расскажу подробно про прием этого препарата.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine2_4Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3EcuMind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1ChoiseLine2_4Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)<br><br><strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine2_4', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1ChoiseLine3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Давайте все-таки продолжим вводить экулизумаб  в сокращенном интервале - 1 раз в 12 дней - и посмотрим динамику.<br><br>900мг внутривенно капельно 1 раз в 12 дней.<br><br>Жду Вас на повторный прием через 6 месяцев.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine3Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine3_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1ChoiseLine3Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Элизария®</strong><br>ЛП-№(000140)-(РГ-RU) от 18.02.2021',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1ChoiseLine3_2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Спасибо, доктор! Надеюсь, это поможет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEP1ChoiseLine3Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP1ChoiseLine3Finish: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'sergeyEP2Cabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    sergeyEP2Cabinet: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'sergeyEP2Analyzes',
        cardClick: 'sergeyEP2CardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'sergeyEP2CardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2CardFirst: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyEP2Analyzes",
            closeClick: "sergeyEP2tuktuk",
            pages: [`${base}/images/patient_sergey_ep1_ep2_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2Card: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyEP2AnalyzesAfter",
            closeClick: "sergeyEP2FirstQuestion",
            pages: [`${base}/images/patient_sergey_ep1_ep2_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2tuktuk: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тихий стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'sergeyEP2enter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2enter: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Добрый день. Здравствуйте.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyEnter.jpg`,
        buttons: [
            {text: "Здравствуйте, ну как вы?", type: "nextStep", gotoStep:'sergeyEP2FirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2FirstQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Я все так же. Без изменений. Хотя отпуск вот взял.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'sergeyEP2Questions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'sergeyEP2AnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEP2AfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2Questions: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Усталость", type: "nextStep", gotoStep:'sergeyEP2Question1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в животе", type: "nextStep", gotoStep:'sergeyEP2Question2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Трансфузии", type: "nextStep", gotoStep:'sergeyEP2Question3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'sergeyEP2Question4', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'sergeyEP2Question5', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'sergeyEP2Question6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'sergeyEP2Question7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'sergeyEP2Question8', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEP2FirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2Question1: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Усталость такая же, как и была. Устал уже от усталости.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyEP2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2Question2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyEP2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2Question3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'За последние полгода дважды назначал доктор из-за низкого гемоглобина.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyEP2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2Question4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyEP2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2Question5: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Стараюсь сейчас больше отдыхать наоборот, пока отпуск. Хочу немного накопить энергии.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyEP2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2Question6: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyEP2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2Question7: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Да, обратил внимание, было несколько раз.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyEP2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2Question8: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyEP2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2Analyzes: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyEP2CardFirst",
            nextClick: "sergeyEP2tuktuk",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_ep2_1_table.jpg`],
                [`${base}/images/analiz_sergey_ep2_2_table.jpg`],
                [`${base}/images/analiz_sergey_ep2_3_table.jpg`],
                [`${base}/images/analiz_sergey_ep2_4_table.jpg`],
                [`${base}/images/analiz_sergey_ep2_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2AnalyzesAfter: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyEP2Card",
            nextClick: "sergeyEP2FirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_ep2_1_table.jpg`],
                [`${base}/images/analiz_sergey_ep2_2_table.jpg`],
                [`${base}/images/analiz_sergey_ep2_3_table.jpg`],
                [`${base}/images/analiz_sergey_ep2_4_table.jpg`],
                [`${base}/images/analiz_sergey_ep2_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2AfterQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'sergeyEP2Osmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEP2Mind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2Osmotr: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'sergeyEP2Osmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'sergeyEP2Osmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'sergeyEP2Osmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEP2AfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2Osmotr1: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тахикардия. ЧСС - 110 уд/м',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEP2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2Osmotr2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Кожные покровы менее бледные, но желтушность сохраняется',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEP2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2Osmotr3: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Все в норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEP2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2Mind: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>У пациента уже длительное время наблюдается субоптимальный ответ на патогенетическую терапию, выражающийся в низком уровне гемоглобина и трансфузионной зависимости. Надо предпринять меры по коррекции терапии.<br><br>Результаты лабораторных исследований могут свидетельствовать об активном внутрисосудистом и внесосудистом гемолизе, выражающихся в:<ul><li>Снижении уровня гемоглобина</li><li>Повышенная активность ЛДГ >1.5хВГН</li><li>Гипербилирубинемия за счёт непрямой фракции >1.5хВГН</li><li>Ретикулоцитоз >120 тыс/мкл</li><li>Положительная прямая проба Кумбса</li></ul>Учитывая данные факторы, продолжить терапию ингибиторами-С5 или рассмотреть новые опции лечения?</i>',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEP2MindLink', value: false, redColor: false, answered: false},
            {text: "Равулизумаб", type: "nextStep", gotoStep:'sergeyEP2ChoiseLine1', value: false, redColor: false, answered: false},
            {text: "Иптакопан", type: "nextStep", gotoStep:'sergeyEP2ChoiseLine2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2MindLink: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024. </strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEP2Mind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2ChoiseLine1: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Давайте сменим терапию.<br><br>Через 2 недели после последней инфузии экулизумаба мы введем первую <strong>нагрузочную дозу</strong> равулизумаба. Затем <strong>поддерживающая доза</strong> будет вводиться каждые 8 недель.<br><br>Я Вам подробно распишу схему перехода и через 6 месяцев жду вас на прием с результатами анализов!',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEP2ChoiseLine1Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEP2ChoiseLine1_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2ChoiseLine1Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Ултомирис®</strong><br>ЛП-№(001862)-(РГ-RU) от 28.02.2023',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEP2ChoiseLine1', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2ChoiseLine1_2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Спасибо, доктор! Надеюсь, это поможет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'sergeyEP2ChoiseLine1Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2ChoiseLine1Finish: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'sergeyR1EcuCabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2ChoiseLine2: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>Пациент в настоящее время имеет субоптимальный ответ на патогенетическую терапию - низкий уровень гемоглобина. Недостаточный ответ на терапию может быть связан с активным внутри- и внесосудистым гемолизом, на которые указывают показатели гемоглобина, ЛДГ, билирубина, ретикулоцитов, а также положительная прямая проба Кумбса. У данного пациента есть показания для назначения иптакопана.</i>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyEP2ChoiseLine2Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "closeTelegramBot", gotoStep:'sergeyIPTA2Cabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyEP2ChoiseLine2Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024. </strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)<br><br><strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyEP2ChoiseLine2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    sergeyR1Cabinet: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'sergeyR1Analyzes',
        cardClick: 'sergeyR1CardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'sergeyR1CardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1CardFirst: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyR1Analyzes",
            closeClick: "sergeyR1tuktuk",
            pages: [`${base}/images/patient_sergey_r1_r2_r3_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Card: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyR1AnalyzesAfter",
            closeClick: "sergeyR1FirstQuestion",
            pages: [`${base}/images/patient_sergey_r1_r2_r3_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1tuktuk: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тихий стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'sergeyR1enter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1enter: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Здравствуйте, доктор. Это снова я. Фух!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyEnter.jpg`,
        buttons: [
            {text: "Здравствуйте, как Ваше самочувствие?", type: "nextStep", gotoStep:'sergeyR1FirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1FirstQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Лечусь, лечусь... Пока что хвастаться нечем. Очень хочется в следующий отпуск с дочкой поехать в горы.. Но вот не знаю.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'sergeyR1Questions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'sergeyR1AnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR1AfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Questions: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Усталость", type: "nextStep", gotoStep:'sergeyR1Question1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в животе", type: "nextStep", gotoStep:'sergeyR1Question2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Трансфузии", type: "nextStep", gotoStep:'sergeyR1Question3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'sergeyR1Question4', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'sergeyR1Question5', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'sergeyR1Question6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'sergeyR1Question7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'sergeyR1Question8', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR1FirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Question1: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Стало несколько лучше. Но на работе в течение дня нужно делать перерывы, чтобы отдохнуть.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Question2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Question3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Была одна... Да, я болел снова. Край у нас суровый, сами знаете...',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Question4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Question5: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет... Это мне пока не под силу.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Question6: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Question7: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Не было.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Question8: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Analyzes: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyR1CardFirst",
            nextClick: "sergeyR1tuktuk",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_r1_1_table.jpg`],
                [`${base}/images/analiz_sergey_r1_2_table.jpg`],
                [`${base}/images/analiz_sergey_r1_3_table.jpg`],
                [`${base}/images/analiz_sergey_r1_4_table.jpg`],
                [`${base}/images/analiz_sergey_r1_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1AnalyzesAfter: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyR1Card",
            nextClick: "sergeyR1FirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_r1_1_table.jpg`],
                [`${base}/images/analiz_sergey_r1_2_table.jpg`],
                [`${base}/images/analiz_sergey_r1_3_table.jpg`],
                [`${base}/images/analiz_sergey_r1_4_table.jpg`],
                [`${base}/images/analiz_sergey_r1_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1AfterQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'sergeyR1Osmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR1Attantion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Osmotr: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'sergeyR1Osmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'sergeyR1Osmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'sergeyR1Osmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR1AfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Osmotr1: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тахикардия. ЧСС - 102 уд/м',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR1Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Osmotr2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Кожные покровы менее бледные, но желтушность сохраняется',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR1Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Osmotr3: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Все в норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR1Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Attantion: {
        patient: 'Sergey',
        branch: 0,
        name: '⚠️ ВНИМАНИЕ!',
        text: '📘 Доступен новый материал! Изучите его как можно скорее, чтобы получить награду и увеличить шанс на верный ответ! 🏅🎉<br>👀 Нажмите <strong>"Читать справочник"</strong> – там свежий материал!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Читать справочник", type: "nextStep", gotoStep:'sergeyR1Docs', value: false, redColor: true, answered: false},
            {text: "Обдумать варианты", type: "nextStep", gotoStep:'sergeyR1Choise', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Docs: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "sergeyGematogenR1",
            pages: [
                {image: `${base}/images/sergey_teach_r1_1.png`, scroll: true},
            ]
        }
    },
    sergeyGematogenR1: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR1Attantion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Choise: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Иптакопан", type: "nextStep", gotoStep:'sergeyR1ChoiseLine1', value: false, redColor: false, answered: false},
            {text: "Продолжить терапию равулизумабом", type: "nextStep", gotoStep:'sergeyR1ChoiseLine2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1ChoiseLine1: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>Пациент в настоящее время имеет субоптимальный ответ на патогенетическую терапию - низкий уровень гемоглобина. Недостаточный ответ на терапию может быть связан с активным внутри- и внесосудистым гемолизом, на которые указывают показатели гемоглобина, ЛДГ, билирубина, ретикулоцитов, а также положительная прямая проба Кумбса. У данного пациента есть показания для назначения иптакопана.</i>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyR1ChoiseLine1Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR1ChoiseLine1_2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1ChoiseLine1Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024. </strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)<br><br><strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR1ChoiseLine1', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1ChoiseLine1_2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'У Вас наблюдается высокая активность заболевания, есть признаки и внесосудистого, и внутрисосудистого гемолиза. Я назначаю Вам терапию иптакопаном. Давайте я Вам расскажу подробно про прием этого препарата.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyR1ChoiseLine1_2Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3RavuMind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1ChoiseLine1_2Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024. </strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)<br><br><strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR1ChoiseLine1_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1ChoiseLine2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Давайте пока не будем менять текущую терапию.<br><br>Продолжайте лечение и приходите с результатами обследований через 6 месяцев.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyR1ChoiseLine2Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR1ChoiseLine2_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1ChoiseLine2Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Ултомирис®</strong><br>ЛП-№(001862)-(РГ-RU) от 28.02.2023',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR1ChoiseLine2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1ChoiseLine2_2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Спасибо, доктор! Хорошего Вам дня! До следующего приема тогда!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'sergeyR1ChoiseLine2Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1ChoiseLine2Finish: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'sergeyR2Cabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    sergeyR1EcuCabinet: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'sergeyR1EcuAnalyzes',
        cardClick: 'sergeyR1EcuCardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'sergeyR1EcuCardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuCardFirst: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyR1EcuAnalyzes",
            closeClick: "sergeyR1Ecutuktuk",
            pages: [`${base}/images/patient_sergey_r1_r2_r3_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuCard: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyR1EcuAnalyzesAfter",
            closeClick: "sergeyR1EcuFirstQuestion",
            pages: [`${base}/images/patient_sergey_r1_r2_r3_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Ecutuktuk: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тихий стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'sergeyR1Ecuenter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1Ecuenter: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Здравствуйте, доктор. Это снова я. Фух!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyEnter.jpg`,
        buttons: [
            {text: "Здравствуйте, как Ваше самочувствие?", type: "nextStep", gotoStep:'sergeyR1EcuFirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuFirstQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Лечусь, лечусь... Пока что хвастаться нечем. Очень хочется в следующий отпуск с дочкой поехать в горы.. Но вот не знаю.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'sergeyR1EcuQuestions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'sergeyR1EcuAnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR1EcuAfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuQuestions: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Усталость", type: "nextStep", gotoStep:'sergeyR1EcuQuestion1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в животе", type: "nextStep", gotoStep:'sergeyR1EcuQuestion2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Трансфузии", type: "nextStep", gotoStep:'sergeyR1EcuQuestion3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'sergeyR1EcuQuestion4', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'sergeyR1EcuQuestion5', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'sergeyR1EcuQuestion6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'sergeyR1EcuQuestion7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'sergeyR1EcuQuestion8', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR1EcuFirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuQuestion1: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Стало несколько лучше. Но на работе в течение дня нужно делать перерывы, чтобы отдохнуть.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR1EcuQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuQuestion2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR1EcuQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuQuestion3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Была одна... Да, я болел снова. Край у нас суровый, сами знаете...',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR1EcuQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuQuestion4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR1EcuQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuQuestion5: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет... Это мне пока не под силу.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR1EcuQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuQuestion6: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR1EcuQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuQuestion7: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Не было.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR1EcuQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuQuestion8: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR1EcuQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuAnalyzes: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyR1EcuCardFirst",
            nextClick: "sergeyR1Ecutuktuk",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_r1_1_table.jpg`],
                [`${base}/images/analiz_sergey_r1_2_table.jpg`],
                [`${base}/images/analiz_sergey_r1_3_table.jpg`],
                [`${base}/images/analiz_sergey_r1_4_table.jpg`],
                [`${base}/images/analiz_sergey_r1_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuAnalyzesAfter: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyR1EcuCard",
            nextClick: "sergeyR1EcuFirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_r1_1_table.jpg`],
                [`${base}/images/analiz_sergey_r1_2_table.jpg`],
                [`${base}/images/analiz_sergey_r1_3_table.jpg`],
                [`${base}/images/analiz_sergey_r1_4_table.jpg`],
                [`${base}/images/analiz_sergey_r1_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuAfterQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'sergeyR1EcuOsmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR1EcuMind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuOsmotr: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'sergeyR1EcuOsmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'sergeyR1EcuOsmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'sergeyR1EcuOsmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR1EcuAfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuOsmotr1: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тахикардия. ЧСС - 102 уд/м',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR1EcuOsmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuOsmotr2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Кожные покровы менее бледные, но желтушность сохраняется',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR1EcuOsmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuOsmotr3: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Все в норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR1EcuOsmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuMind: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>Пациент уже длительное время получает терапию ингибитором С5. Результаты лабораторных исследований указывают на субоптимальный ответ на патогенетическую терапию, выражающуюся в уровне гемоглобина в границах между 80 и 100 г/л, а также в трансфузионной зависимости. За последние 6 месяцев также была проведена одна гемотрансфузия.<br><br>У пациента также отмечаются признаки активного внутрисосудистого и внесосудистого гемолиза, выражающихся в:<ul><li>Снижение уровня гемоглобина</li><li>Повышенная активность ЛДГ >1.5хВГН</li><li>Гипербилирубинемия за счёт непрямой фракции >1.5хВГН</li><li>Ретикулоцитоз >120 тыс/мкл</li><li>Положительная прямая проба Кумбса</li></ul></i>',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyR1EcuMindLink', value: false, redColor: false, answered: false},
            {text: "Обдумать варианты", type: "nextStep", gotoStep:'sergeyR1EcuChoise', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuMindLink: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024. </strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR1EcuMind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuChoise: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Иптакопан", type: "nextStep", gotoStep:'sergeyR1EcuChoiseLine1', value: false, redColor: false, answered: false},
            {text: "Продолжить терапию равулизумабом", type: "nextStep", gotoStep:'sergeyR1EcuChoiseLine2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuChoiseLine1: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>Пациент в настоящее время имеет субоптимальный ответ на патогенетическую терапию - низкий уровень гемоглобина. Недостаточный ответ на терапию может быть связан с активным внутри- и внесосудистым гемолизом, на которые указывают показатели гемоглобина, ЛДГ, билирубина, ретикулоцитов, а также положительная прямая проба Кумбса. У данного пациента есть показания для назначения иптакопана.</i>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyR1EcuChoiseLine1Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR1EcuChoiseLine1_2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuChoiseLine1Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024. </strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)<br><br><strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR1EcuChoiseLine1', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuChoiseLine1_2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'У Вас наблюдается высокая активность заболевания, есть признаки и внесосудистого, и внутрисосудистого гемолиза. Я назначаю Вам терапию иптакопаном. Давайте я Вам расскажу подробно про прием этого препарата.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyR1EcuChoiseLine1_2Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3RavuMind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuChoiseLine1_2Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024. </strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)<br><br><strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR1EcuChoiseLine1_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuChoiseLine2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Давайте пока не будем менять текущую терапию.<br><br>Продолжайте лечение и приходите с результатами обследований через 6 месяцев.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyR1EcuChoiseLine2Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR1EcuChoiseLine2_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuChoiseLine2Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Ултомирис®</strong><br>ЛП-№(001862)-(РГ-RU) от 28.02.2023',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR1EcuChoiseLine2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuChoiseLine2_2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Спасибо, доктор! Хорошего Вам дня! До следующего приема тогда!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'sergeyR1EcuChoiseLine2Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR1EcuChoiseLine2Finish: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'sergeyR2Cabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    sergeyR2Cabinet: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'sergeyR2Analyzes',
        cardClick: 'sergeyR2CardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'sergeyR2CardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2CardFirst: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyR2Analyzes",
            closeClick: "sergeyR2tuktuk",
            pages: [`${base}/images/patient_sergey_r1_r2_r3_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2Card: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyR2AnalyzesAfter",
            closeClick: "sergeyR2FirstQuestion",
            pages: [`${base}/images/patient_sergey_r1_r2_r3_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2tuktuk: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тихий стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'sergeyR2enter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2enter: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Добрый день. Я пришел на повторный визит, как и договаривались.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyEnter.jpg`,
        buttons: [
            {text: "Здравствуйте, ну как вы?", type: "nextStep", gotoStep:'sergeyR2FirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2FirstQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Да не знаю я что-то, как я. Не очень, пожалуй, если уж совсем честно. Как-то мне лечение не особо помогает, не чувствую я этого. Мне дочь нарисовала картинку как мы с ней в горах... Я снова пообещал ей в следующий раз поехать...',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'sergeyR2Questions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'sergeyR2AnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR2AfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2Questions: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Усталость", type: "nextStep", gotoStep:'sergeyR2Question1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в животе", type: "nextStep", gotoStep:'sergeyR2Question2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Трансфузии", type: "nextStep", gotoStep:'sergeyR2Question3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'sergeyR2Question4', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'sergeyR2Question5', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'sergeyR2Question6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'sergeyR2Question7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'sergeyR2Question8', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR2FirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2Question1: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Самое трудное - это продолжать работать. Не знаю, наверное, надо увольняться.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2Question2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2Question3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Не было.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2Question4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2Question5: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Ой, доктор. Не спрашивайте. Моя главная физическая нагрузка - это встать с кровати и прожить день. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2Question6: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2Question7: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Периодически бывает.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2Question8: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2Analyzes: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyR2CardFirst",
            nextClick: "sergeyR2tuktuk",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_r2_1_table.jpg`],
                [`${base}/images/analiz_sergey_r2_2_table.jpg`],
                [`${base}/images/analiz_sergey_r2_3_table.jpg`],
                [`${base}/images/analiz_sergey_r2_4_table.jpg`],
                [`${base}/images/analiz_sergey_r2_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [361],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2AnalyzesAfter: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyR2Card",
            nextClick: "sergeyR2FirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_r2_1_table.jpg`],
                [`${base}/images/analiz_sergey_r2_2_table.jpg`],
                [`${base}/images/analiz_sergey_r2_3_table.jpg`],
                [`${base}/images/analiz_sergey_r2_4_table.jpg`],
                [`${base}/images/analiz_sergey_r2_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [361],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2AfterQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'sergeyR2Osmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR2Mind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2Osmotr: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'sergeyR2Osmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'sergeyR2Osmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'sergeyR2Osmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR2AfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2Osmotr1: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тахикардия. ЧСС - 107 уд/м',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2Osmotr2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Кожные покровы менее бледные, но желтушность сохраняется',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2Osmotr3: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Все в норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2Mind: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>Текущий курс терапии не позволил достичь ожидаемых результатов. За последние 6 месяцев уровень гемоглобина упал ниже 90 г/л, общий уровень билирубина также превысил 1.5хВГН. Помимо этого у пациента наблюдается ретикулоцитоз, а также прямая проба Кумбса стала положительной! Все это может указывать на возникший на фоне терапии C5 внесосудистый гемолиз, а также сохраняющийся внутрисосудистый гемолиз. У пациента все еще субоптимальный ответ на текущую патогенетическую терапию.<br><br>Стоит ли рассмотреть новые опции терапии?</i>',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyR2MindLink', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR2AfterFisk', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2MindLink: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR2Mind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2AfterFisk: {
        patient: 'Sergey',
        branch: 0,
        name: '⚠️ ВНИМАНИЕ!',
        text: '📘 Доступны новые материалы! Изучите их как можно скорее, чтобы получить награду и увеличить шанс на верный ответ! 🏅🎉<br>👀 Нажмите <strong>"Читать справочник"</strong>.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Читать справочник", type: "nextStep", gotoStep:'sergeyR2Docs', value: false, redColor: true, answered: false},
            {text: "Обдумать варианты", type: "nextStep", gotoStep:'sergeyR2Choise', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2Docs: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "sergeyGematogenR2",
            pages: [
                {image: `${base}/images/sergey_teach_r2_1.png`, scroll: true},
                {image: `${base}/images/sergey_teach_r2_2.png`, scroll: true},
                {image: `${base}/images/sergey_teach_r2_3.png`, scroll: true},
            ]
        }
    },
    sergeyGematogenR2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR2AfterFisk', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2Choise: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Продолжить терапию равулизумабом", type: "nextStep", gotoStep:'sergeyR2ChoiseLine1', value: false, redColor: false, answered: false},
            {text: "Иптакопан", type: "nextStep", gotoStep:'sergeyR2ChoiseLine2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2ChoiseLine1: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Давайте пока не будем менять текущий курс терапии.<br><br>Продолжайте лечение и приходите с результатами исследований через 6 месяцев.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyR2ChoiseLine1Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR2ChoiseLine1_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2ChoiseLine1Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Ултомирис®</strong><br>ЛП-№(001862)-(РГ-RU) от 28.02.2023',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR2ChoiseLine1', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2ChoiseLine1_2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Спасибо! Верю в лучшее. Увидимся через 6 месяцев. Надеюсь, приду бодрым и веселым! Горы ждут... Точнее, дочка ждет. До встречи!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR2ChoiseLine1_3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2ChoiseLine1_3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Надя',
        text: 'А какие горы? Алтай? Урал?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR2ChoiseLine1_4', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2ChoiseLine1_4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Эльбрус. Моя мечта с детства.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet2.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR2ChoiseLine1_5', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2ChoiseLine1_5: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Не сдаёмся, Сергей. Мечты должны сбываться. Продолжаем лечение. До встречи! ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR2ChoiseLine1Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2ChoiseLine1Finish: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'sergeyR3Cabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2ChoiseLine2: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>В связи с возникшим внесосудистым гемолизом есть основания рассмотреть другие опции патогенетической терапии ПНГ, действие которых направлено на проксимальный участок системы комплемента. Что можно назначить данному пациенту?</i>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyR2ChoiseLine2Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR2ChoiseLine2_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2ChoiseLine2Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)<br><br><strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR2ChoiseLine2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2ChoiseLine2_2: {
        patient: 'Sergey',
        branch: 0,
        name: '⚠️ ВНИМАНИЕ!',
        text: '📘 Доступны новые материалы! Изучите их как можно скорее, чтобы получить награду и увеличить шанс на верный ответ! 🏅🎉<br>👀 Нажмите <strong>"Читать справочник"</strong>.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Читать справочник", type: "nextStep", gotoStep:'sergeyR2DocsLine2', value: false, redColor: true, answered: false},
            {text: "Сделать назначение", type: "nextStep", gotoStep:'sergeyR2ChoiseLine2_4', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2DocsLine2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "sergeyGematogenR2Line2",
            pages: [
                {image: `${base}/images/sergey_teach_r2_11.png`, scroll: true},
                {image: `${base}/images/sergey_teach_r2_12.png`, scroll: true},
                {image: `${base}/images/sergey_teach_r2_13.png`, scroll: true},
            ]
        }
    },
    sergeyGematogenR2Line2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR2ChoiseLine2_2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2ChoiseLine2_4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'У вас наблюдаются признаки внутри- и внесосудистого гемолиза, поэтому необходимо сменить терапию с терминального ингибитора системы комплемента на проксимальный ингибитор - иптакопан. Давайте я Вам расскажу подробно про прием этого препарата.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyR2ChoiseLine2_4Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyEnterLine3RavuMind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR2ChoiseLine2_4Link: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)<br><br><strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR2ChoiseLine2_4', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    sergeyR3Cabinet: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'sergeyR3Analyzes',
        cardClick: 'sergeyR3CardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'sergeyR3CardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3CardFirst: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyR3Analyzes",
            closeClick: "sergeyR3tuktuk",
            pages: [`${base}/images/patient_sergey_r1_r2_r3_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Card: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyR3AnalyzesAfter",
            closeClick: "sergeyR3FirstQuestion",
            pages: [`${base}/images/patient_sergey_r1_r2_r3_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3tuktuk: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тихий стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'sergeyR3enter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3enter: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Доктор. Добрый день. Что-то я уже теряю надежду. Хожу-хожу, лечусь - все только хуже и хуже. Я уже не знаю. Извините, что я так сразу с порога. Я, пожалуй, присяду. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyEnter.jpg`,
        buttons: [
            {text: "Проходите, пожалуйста.", type: "nextStep", gotoStep:'sergeyR3enter2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3enter2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyEnter.jpg`,
        buttons: [
            {text: "Как сейчас себя чувствуете?", type: "nextStep", gotoStep:'sergeyR3FirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3FirstQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Пешком хотел до Вас дойти - не смог. Попросил товарища подвезти. Честно - я уже и привыкать начинаю. Нет сил и нет. Другое дело, что я часто болею: то температура, то кашель. Я, конечно, понимаю: на Севере живем. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'sergeyR3Questions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'sergeyR3AnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR3AfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Questions: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Усталость", type: "nextStep", gotoStep:'sergeyR3Question1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в животе", type: "nextStep", gotoStep:'sergeyR3Question2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Трансфузии", type: "nextStep", gotoStep:'sergeyR3Question3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'sergeyR3Question4', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'sergeyR3Question5', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'sergeyR3Question6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'sergeyR3Question7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'sergeyR3Question8', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR3FirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Question1: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Работать очень сложно. Все время беру отгулы и перерывы. В мое положение вроде бы и входят.. Не знаю, что будет раньше: меня уволят или я сам уволюсь.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Question2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Question3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Опять болел. Вроде не тяжелые инфекции, температура невысокая, но динамика в показателях была. Так терапевт сказал.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Question4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Question5: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Даже не спрашивайте. Прогресса нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Question6: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Да тут вроде бы нормально.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Question7: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Кажется, пару раз было.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Question8: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyR3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Analyzes: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyR3CardFirst",
            nextClick: "sergeyR3tuktuk",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_r3_1_table.jpg`],
                [`${base}/images/analiz_sergey_r3_2_table.jpg`],
                [`${base}/images/analiz_sergey_r3_3_table.jpg`],
                [`${base}/images/analiz_sergey_r3_4_table.jpg`],
                [`${base}/images/analiz_sergey_r3_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3AnalyzesAfter: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyR3Card",
            nextClick: "sergeyR3FirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_r3_1_table.jpg`],
                [`${base}/images/analiz_sergey_r3_2_table.jpg`],
                [`${base}/images/analiz_sergey_r3_3_table.jpg`],
                [`${base}/images/analiz_sergey_r3_4_table.jpg`],
                [`${base}/images/analiz_sergey_r3_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3AfterQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'sergeyR3Osmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR3Mind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Osmotr: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'sergeyR3Osmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'sergeyR3Osmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'sergeyR3Osmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyR3AfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Osmotr1: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Тахикардия. ЧСС - 95 уд/м',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR3Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Osmotr2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Кожные покровы стали очень бледными, желтушность склер усилилась',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR3Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Osmotr3: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Все в норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR3Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Mind: {
        patient: 'Sergey',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>У пациента уже длительное время наблюдается субоптимальный ответ на терапию ингибиторами C5, характеризующийся низким уровнем гемоглобина и трансфузионной зависимостью, у пациента имеются признаки внесосудистого гемолиза. Текущий курс терапии не способствовал достижению поставленных терапевтических целей. Необходимо принять решение о дальнейших шагах.</i>',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyR3MindLink', value: false, redColor: false, answered: false},
            {text: "Обдумать варианты", type: "nextStep", gotoStep:'sergeyR3Doctor', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3MindLink: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024. </strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR3Mind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Doctor: {
        patient: 'Sergey',
        branch: 0,
        name: 'Надя',
        text: 'Доктор, а Вы уже читали статью про новый препарат иптакопан? ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {text: "Читать статью", type: "nextStep", gotoStep:'sergeyR3Docs', value: false, redColor: true, answered: false},
            {text: "Предложить новое лечение", type: "nextStep", gotoStep:'sergeyR3Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Docs: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "sergeyGematogenR3",
            pages: [
                {image: `${base}/images/sergey_teach_r3_1.png`, scroll: true},
                {image: `${base}/images/sergey_teach_r3_2.png`, scroll: true},
            ]
        }
    },
    sergeyGematogenR3: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR3Doctor', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3Finish: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'К сожалению, текущая терапия не позволила добиться оптимального ответа. Возможно, что это связано с продолжающимся внесосудистым гемолизом, выражающимся такими признаками, как положительная проба Кумбса, ретикулоцитоз, гипербилирубинемия за счет непрямой фракции.<br><br>Есть основания для переключения на терапию ингибиторами, воздействующими на проксимальное звено системы комплемента. Я назначаю Вам иптакопан, давайте расскажу, что это за препарат и как будет происходить лечение.',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'sergeyR3FinishLink', value: false, redColor: false, answered: false},
            {text: "Иптакопан", type: "nextStep", gotoStep:'sergeyIPTA2Cabinet', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyR3FinishLink: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024. </strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)<br><br><strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyR3Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    sergeyIPTA2Cabinet: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'sergeyIPTA2Analyzes',
        cardClick: 'sergeyIPTA2CardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'sergeyIPTA2CardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2CardFirst: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyIPTA2Analyzes",
            closeClick: "sergeyIPTA2tuktuk",
            pages: [`${base}/images/patient_sergey_ipta2_ipta3_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2Card: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyIPTA2AnalyzesAfter",
            closeClick: "sergeyIPTA2FirstQuestion",
            pages: [`${base}/images/patient_sergey_ipta2_ipta3_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2tuktuk: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Уверенный стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'sergeyIPTA2enter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2enter: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyEnter2.jpg`,
        buttons: [
            {text: "Как сейчас себя чувствуете?", type: "nextStep", gotoStep:'sergeyIPTA2FirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2FirstQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Доктор! Надя! Мне стало настолько лучше, что и не передать! Пешком к Вам пришел и не устал! Если так и дальше пойдет - начинаю планировать отпуск в горах!  ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'sergeyIPTA2Questions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'sergeyIPTA2AnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyIPTA2AfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2Questions: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Усталость", type: "nextStep", gotoStep:'sergeyIPTA2Question1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в животе", type: "nextStep", gotoStep:'sergeyIPTA2Question2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Трансфузии", type: "nextStep", gotoStep:'sergeyIPTA2Question3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'sergeyIPTA2Question4', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'sergeyIPTA2Question5', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'sergeyIPTA2Question6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'sergeyIPTA2Question7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'sergeyIPTA2Question8', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyIPTA2FirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2Question1: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Устаю теперь, только если поработаю как следует. В конце дня! Как было до болезни.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyIPTA2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2Question2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Да тут вроде бы нормально.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyIPTA2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2Question3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Не было, доктор. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyIPTA2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2Question4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Не было! ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyIPTA2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2Question5: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Готовлюсь к походу: зарядка 3 раза в неделю.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyIPTA2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2Question6: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyIPTA2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2Question7: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Не было! ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyIPTA2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2Question8: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Да тут вроде бы нормально.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyIPTA2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2Analyzes: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyIPTA2CardFirst",
            nextClick: "sergeyIPTA2tuktuk",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_ipta2_1_table.jpg`],
                [`${base}/images/analiz_sergey_ipta2_2_table.jpg`],
                [`${base}/images/analiz_sergey_ipta2_3_table.jpg`],
                [`${base}/images/analiz_sergey_ipta2_4_table.jpg`],
                [`${base}/images/analiz_sergey_ipta2_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [361],
                [342],
                [472],
                [296]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2AnalyzesAfter: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyIPTA2Card",
            nextClick: "sergeyIPTA2FirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_ipta2_1_table.jpg`],
                [`${base}/images/analiz_sergey_ipta2_2_table.jpg`],
                [`${base}/images/analiz_sergey_ipta2_3_table.jpg`],
                [`${base}/images/analiz_sergey_ipta2_4_table.jpg`],
                [`${base}/images/analiz_sergey_ipta2_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [361],
                [342],
                [472],
                [296]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2AfterQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'sergeyIPTA2Osmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyIPTA2AfterFisk', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2Osmotr: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'sergeyIPTA2Osmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'sergeyIPTA2Osmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'sergeyIPTA2Osmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyIPTA2AfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2Osmotr1: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'В пределах нормы. ЧСС - 90 уд/мин',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyIPTA2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2Osmotr2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Нормальные кожные покровы. Желтизна тоже исчезла.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyIPTA2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2Osmotr3: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Пальпация живота безболезненная, без особенностей',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyIPTA2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2AfterFisk: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Сергей! Я так за Вас рада! Эльбрусу быть, получается!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyIPTA2Next', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2Next: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Сергей Александрович, динамика отличная. Жду Вас на контрольном осмотре через 3 месяца.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyIPTA2Next2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2Next2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Буду!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet2.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyIPTA2Finish', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA2Finish: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'sergeyIPTA3Cabinet', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    sergeyIPTA3Cabinet: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'sergeyIPTA3Analyzes',
        cardClick: 'sergeyIPTA3CardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'sergeyIPTA3CardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3CardFirst: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyIPTA3Analyzes",
            closeClick: "sergeyIPTA3tuktuk",
            pages: [`${base}/images/patient_sergey_ipta2_ipta3_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3Card: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "sergeyIPTA3AnalyzesAfter",
            closeClick: "sergeyIPTA3FirstQuestion",
            pages: [`${base}/images/patient_sergey_ipta2_ipta3_card1.png`, `${base}/images/patient_sergey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3tuktuk: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Уверенный стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'sergeyIPTA3enter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3enter: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyEnter2.jpg`,
        buttons: [
            {text: "Здравствуйте, ну как Вы?", type: "nextStep", gotoStep:'sergeyIPTA3FirstQuestion_0', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3FirstQuestion_0: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Я отлично. Билеты купил в Минеральные воды. Эльбрус покорять будем! Дочка до потолка прыгала. Чувствую себя замечательно! Спасибо Вам большое!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyIPTA3FirstQuestion', value: false, redColor: false, answered: true, canDisabled: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3FirstQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Это прекрасно! Давайте Вас все-таки осмотрим.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'sergeyIPTA3Questions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'sergeyIPTA3AnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyIPTA3AfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3Questions: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Усталость", type: "nextStep", gotoStep:'sergeyIPTA3Question1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в животе", type: "nextStep", gotoStep:'sergeyIPTA3Question2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Трансфузии", type: "nextStep", gotoStep:'sergeyIPTA3Question3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'sergeyIPTA3Question4', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'sergeyIPTA3Question5', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'sergeyIPTA3Question6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'sergeyIPTA3Question7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'sergeyIPTA3Question8', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyIPTA3FirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3Question1: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Состояние очень похоже на то, как было до того, как я заболел. То есть отлично себя чувствую, не побоюсь этого слова.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyIPTA3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3Question2: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyIPTA3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3Question3: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Не было, доктор. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyIPTA3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3Question4: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyIPTA3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3Question5: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Спорт регулярен! Даже немного мышечную массу удалось вернуть! ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyIPTA3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3Question6: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyIPTA3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3Question7: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Не было.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyIPTA3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3Question8: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Нет, доктор, все в порядке, ничего не болит. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'sergeyIPTA3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3Analyzes: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyIPTA3CardFirst",
            nextClick: "sergeyIPTA3tuktuk",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_ipta3_1_table.jpg`],
                [`${base}/images/analiz_sergey_ipta3_2_table.jpg`],
                [`${base}/images/analiz_sergey_ipta3_3_table.jpg`],
                [`${base}/images/analiz_sergey_ipta3_4_table.jpg`],
                [`${base}/images/analiz_sergey_ipta3_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [361],
                [342],
                [472],
                [296]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3AnalyzesAfter: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/SergeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "sergeyIPTA3Card",
            nextClick: "sergeyIPTA3FirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_sergey_ipta3_1_table.jpg`],
                [`${base}/images/analiz_sergey_ipta3_2_table.jpg`],
                [`${base}/images/analiz_sergey_ipta3_3_table.jpg`],
                [`${base}/images/analiz_sergey_ipta3_4_table.jpg`],
                [`${base}/images/analiz_sergey_ipta3_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [361],
                [342],
                [472],
                [296]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3AfterQuestion: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'sergeyIPTA3Osmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyIPTA3AfterFisk', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3Osmotr: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'sergeyIPTA3Osmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'sergeyIPTA3Osmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'sergeyIPTA3Osmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'sergeyIPTA3AfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3Osmotr1: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'В пределах нормы. ЧСС - 90 уд/мин',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyIPTA3Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3Osmotr2: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Кожные покровы нормальные, без изменений',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyIPTA3Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3Osmotr3: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'Пальпация живота безболезненная, без особенностей',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/SergeyCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'sergeyIPTA3Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3AfterFisk: {
        patient: 'Sergey',
        branch: 0,
        name: 'Вы',
        text: 'Судя по результатам анализов и опроса - данный вид терапии помогает контролировать внутри- и внесосудистый гемолиз. Могу только радоваться! Продолжайте наблюдаться и всего Вам хорошего! ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet2.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'sergeyIPTA3Next', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyIPTA3Next: {
        patient: 'Sergey',
        branch: 0,
        name: 'Сергей',
        text: 'Поверить не могу, что я наконец чувствую себя бодрым... Спасибо Вам! До встречи. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/SergeyCabinet2.jpg`,
        buttons: [
            {text: "Закончить прием", type: "closeTelegramBot", gotoStep:'sergeyFinishLetter', value: false, redColor: false, answered: false, patient: 'Sergey'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    sergeyFinishLetter: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: 'У Вас новое письмо!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: 'patientSergeyCard',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'sergeyFinishLetterOpen', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyFinishLetterOpen: {
        patient: 'Sergey',
        branch: 0,
        name: 'Письмо от Сергея',
        text: 'Доктор и Надя, Вы помогли мне исполнить мою мечту! Пишу вам c гор! Поднимаюсь на Эльбрус. Я так счастлив, что хочется непременно поделиться этим. Неописуемый восторг! Надеюсь, у Вас тоже все хорошо!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: 'patientSergeyCard',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Закрыть", type: "nextStep", gotoStep: 'sergeyFinishLetterClose', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    sergeyFinishLetterClose: {
        patient: 'Sergey',
        branch: 0,
        name: '',
        text: '<strong>Совершенно верно! + 30 баллов!<br><br>🏆 Ваш рейтинг: ???⭐️<br><br>📈 Как повысить рейтинг?</strong><br>✅ За каждый верный ответ вы получаете баллы рейтинга! 🩺🧠<br>✅ Изучение новой информации в приложении увеличивает шансы на верные решения!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/points.mp3`,
        rating: 30,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'start', value: false, redColor: false, answered: false, patient: 'Ivan'},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

}
